import { apiGet, GetReportRequest } from 'api';
import { ReportResponse } from 'types';

export const getLateResponsesReport = (request: GetReportRequest): Promise<ReportResponse> =>
  apiGet<ReportResponse, GetReportRequest>('reports/lateresponses', request);
